import React, { useEffect, useState } from "react";
import { Box, Button, Card, Chip, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { discounts } from "../../../../services/TicketsServices";
import PageWrapper from "../../../../common/PageWrapper/PageWrapper";

function FieldItem({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography sx={{ color: "#777", fontSize: 12, mb: 0.5 }}>{label}</Typography>
      <Typography sx={{ color: "#111" }}>{value ?? "-"}</Typography>
    </Grid>
  );
}

function VisitorTypeChips({ visitorTypes }) {
  const list = Array.isArray(visitorTypes) ? visitorTypes : [];
  if (list.length === 0) return <Typography sx={{ color: "#111" }}>-</Typography>;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {list.map((v) => (
        <Chip key={v?.id || v?.name} label={v?.name || "-"} size="small" />
      ))}
    </Box>
  );
}

function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

export default function DiscountDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    discounts("get", null, null, id)
      .then((res) => {
        if (cancelled) return;
        setData(res?.data || null);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch discount detail:", err);
        if (cancelled) return;
        setData(null);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <PageWrapper>
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">Discount Detail</Typography>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      <Card className={"box-shadow"} sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <FieldItem label="Museum" value={data?.museum_name || data?.museum_id} />
          <FieldItem label="Name" value={data?.name} />
          <FieldItem label="Description" value={data?.description} />
          <FieldItem label="Value" value={data?.value} />
          <FieldItem label="Active" value={data?.is_active ? "Yes" : "No"} />
          <Grid item xs={12} sm={6}>
            <Typography sx={{ color: "#777", fontSize: 12, mb: 0.5 }}>Visitor types</Typography>
            <VisitorTypeChips visitorTypes={data?.visitor_types} />
          </Grid>
          <FieldItem label="Start date" value={formatDateTime(data?.start_date)} />
          <FieldItem label="End date" value={formatDateTime(data?.end_date)} />
          <FieldItem label="Created at" value={formatDateTime(data?.created_at)} />
          <FieldItem label="Updated at" value={formatDateTime(data?.updated_at)} />
        </Grid>
      </Card>
    </Box>
    </PageWrapper>
  );
}
